import { createTheme } from "@mui/material/styles";
import { palette } from "./palette";

export default createTheme({
  palette: {
    primary: {
      main: palette.slate,
    },
    secondary: {
      main: palette.sunburst,
    },
  },
  components: {
    // FormControl component overrides
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& label[data-shrink='false']": {
            top: "-10px",
            color: palette.typography.black.solid,
            transform: `translate(10px, 20px) scale(1)`,
          },
        },
      },
    },
    // FormLabel component overrides
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          "&.Mui-focused": {
            color: palette.blue,
          },
        },
      },
    },
    // Input component overrides
    MuiInput: {
      styleOverrides: {
        underline: {
          borderBottom: `1px solid ${palette.typography.white.high}`,
          "&:before": {
            borderBottom: "none",
          },
          "&:hover:not(.Mui-disabled):before": {
            borderBottom: "none",
          },
          "&:after": {
            borderBottom: "none",
          },
        },
      },
    },
    // OutlinedInput component overrides
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: palette.blue,
          },
        },
        input: {
          fontSize: "0.875rem",
          lineHeight: "1.25rem",
          letterSpacing: "0.0025rem",
          padding: "0.3125rem 0.625rem",
          height: "1.25rem",
          "&::-webkit-input-placeholder": {
            color: palette.typography.black.solid,
            opacity: `1 !important`,
          },
        },
        notchedOutline: {
          fontSize: "0.875rem",
        },
      },
    },
    // FormHelperText component overrides
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "0.625rem",
          textAlign: "right",
        },
        contained: {
          marginRight: 0,
          marginTop: 0,
        },
      },
    },
    // Checkbox component overrides
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: 3,
          "& svg": {
            fontSize: "1rem",
          },
        },
      },
    },
    // FormControlLabel component overrides
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
          lineHeight: "1rem",
          marginRight: 0,
        },
      },
    },
    // Button component overrides
    MuiButton: {
      styleOverrides: {
        root: {
          height: "2rem",
        },
      },
      variants: [
        {
          props: { variant: "text" },
          style: {
            fontSize: "0.875rem",
            lineHeight: "1rem",
            fontWeight: "normal",
            textTransform: "capitalize",
          },
        },
        {
          props: { variant: "outlined" },
          style: {
            fontSize: "0.875rem",
            lineHeight: "1rem",
            fontWeight: "normal",
            textTransform: "capitalize",
          },
        },
        {
          props: { variant: "contained" },
          style: {
            fontSize: "0.875rem",
            lineHeight: "1rem",
            fontWeight: "normal",
            textTransform: "capitalize",
          },
        },
      ],
    },
    // SvgIcon component overrides
    MuiSvgIcon: {
      styleOverrides: {
        colorSecondary: {
          color: palette.typography.white.inactive,
        },
      },
    },
    // TextField component overrides
    MuiTextField: {
      styleOverrides: {
        root: {
          marginTop: 0,
        },
      },
    },
    // Snackbar component overrides
    MuiSnackbar: {
      styleOverrides: {
        anchorOriginTopCenter: {
          top: "50% !important",
        },
      },
    },
    // DatePicker component overrides (if using @mui/lab)
    MuiPickersDay: {
      styleOverrides: {
        daySelected: {
          border: 0,
        },
        current: {
          border: "0.063rem solid #DC0032",
        },
      },
    },
    // Autocomplete component overrides
    MuiAutocomplete: {
      styleOverrides: {
        popupIndicator: {
          transition: "transform linear 200ms",
        },
        popupIndicatorOpen: {
          color: palette.blue,
          transform: "rotate(180deg)",
        },
      },
    },
  },
});
